import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "target", "rel"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("a", {
    href: $props.href,
    target: $options.urlTarget,
    rel: $options.urlRel
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8 /* PROPS */, _hoisted_1))
}